exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#edit-email-page .box[data-v-3ce56200] {\n  padding: 20px;\n}\n", ""]);

// exports
